import styled, { css } from "styled-components";

export const ModalOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    z-index: 20;
    overflow: auto;
`;

export const ModalMain = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: ${props => props.$slide ? 'end' : 'center'};
    justify-content: center;
    overflow: hidden;
`;

export const ModalContainer = styled.div`
    width: 90%;
    height: ${props => props.$slide ? '100%' : 'max-content'};
    display: flex;
    flex-direction: column;
    background-color: var(--theme-color-secondary);
    border: 1px solid var(--border-color);
    border-radius: ${props => props.$slide ? '1rem 0 0 1rem' : '1rem'};
    /* margin: auto; */
    max-width: ${({ width }) => `${width}px`};
    overflow: auto;
`;

export const ModalHead = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px;
    border-bottom: 1px solid var(--border-color);
    
    h4 {
        text-transform: capitalize;
        ${({ type }) =>
        type === 'success' &&
        css`
                color: var(--color-success);
            `}
        ${({ type }) =>
        type === 'error' &&
        css`
                color: var(--color-error);
            `}
        ${({ type }) =>
        type === 'warning' &&
        css`
                color: var(--color-warning);
            `}
    }
`;

export const ModalHeadTop = styled.div`
    // background-color: red;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const ModalCloseButton = styled.div`
    width: 12px;
    height: 12px;
    /* color: #909090; */
    /* border: 1px solid red; */
    /* background-color: rgba(255, 0, 0, 0.15); */
    /* border-radius: 3rem; */
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: 0.4;
    overflow: hidden;
    transition: all ease-in-out 0.3s;

    svg {
        width: 100%;
        height: auto;
        transition: all ease-in-out 0.3s;
    }

    &:hover {
        opacity: 0.6;
    }

    &:hover svg {
        transform: rotate(90deg);
    }
`;

export const SliderRow = styled.div`
    // background-color: yellow;
    display: flex;
    align-items: center;
    width: 60%;

    span {
        white-space: nowrap;
        font-size: 12px;
        font-weight: 500;
    }

    & > div {
        flex: 1;
        min-width: 0;
    }
`;

export const ModalBody = styled.div`
    flex: 1;
    padding: 20px;
    overflow: auto;
    background-color: var(--theme-color-tertiary);

    p {
        margin: 0;
    }
`;